import React, {useState, useEffect} from 'react'
import VerItems from './VerItems'
import SubirEditItemsAdmin from './SubirEditItemsAdmin'
import Eliminar  from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import {Titulos, peticionDelete} from '../hooks/Funciones'

const ItemsAppAdmin = ({baseUrl, titulo}) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [cargas, setCargas] = useTraeDatos(baseUrl)
	const [copiaCargas] = useTraeDatos(baseUrl)
	const [busqueda, setBusqueda] = useState('')
	const TitulosPagina = ['Ver Items App', 'Crear Item App', 'Editar Item App', 'Eliminar Item App', 'Items App']

	const seleccionaRegistro = (dato, funcion) => e =>{
		setRegistroSelect({...dato, imagePrev: dato.imagen})
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaCargas.filter((item) => {
			if(item.nombre.toLowerCase().includes(termino.toLowerCase())){
				return item
			} 
		})
		setCargas(resultado)
	}

	const peticionDeletee = () =>{peticionDelete(registroSelect, baseUrl, cargas, setCargas, setFuncion)}
	useEffect(() => {Titulos (funcion, setTituloPag, TitulosPagina)},[funcion])

	const ReiniciarPaginacion = () => {
		setCargas(copiaCargas)
		setBusqueda('')
	}

	return(
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'Cursos'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda}
				resetBusq={ReiniciarPaginacion}
			/>
            {funcion === 'crear' ?
                <SubirEditItemsAdmin
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={cargas} 
					setData={setCargas}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					funcion={funcion}/>

			:null}
			{funcion === 'editar' ?
				<SubirEditItemsAdmin
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={cargas} 
					setData={setCargas}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					registroSelect={registroSelect}
					funcion={funcion}/>
			:null}
			{funcion === 'ver' ?
				<VerItems
					data={cargas} 
					seleccionaRegistro={seleccionaRegistro}
					baseUrl={baseUrl}
				/>
			:null}
			{funcion === 'eliminar' ?
				<Eliminar 
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee}/>
				
			:null}
		</div>
	)
}

export default ItemsAppAdmin